import React from 'react';

const lanes = [
  {
    image: 'https://images.unsplash.com/photo-1440404653325-ab127d49abc1?auto=format&fit=crop&w=1200&q=80',
    span: 'lg:col-span-7 lg:row-span-2',
    height: 'h-80 lg:h-full',
  },
  {
    image: 'https://images.unsplash.com/photo-1517604931442-7e0c8ed2963c?auto=format&fit=crop&w=1000&q=80',
    span: 'lg:col-span-5',
    height: 'h-64',
  },
  {
    image: 'https://images.unsplash.com/photo-1485846234645-a62644f84728?auto=format&fit=crop&w=1000&q=80',
    span: 'lg:col-span-5',
    height: 'h-64',
  },
  {
    image: 'https://images.unsplash.com/photo-1536440136628-849c177e76a1?auto=format&fit=crop&w=1400&q=80',
    span: 'lg:col-span-12',
    height: 'h-72',
  },
];

const Features = ({ language }) => {
  const texts = {
    lt: {
      eyebrow: 'Kolekcijos',
      title: 'Takeliai pagal vakaro nuotaiką',
      subtitle: 'Kiekvienas takelis turi savo tempą. Atverkite tą, kuris tinka šiam vakarui.',
      open: 'Atidaryti takelį',
      items: [
        {
          title: 'Naktinis miestas',
          text: 'Noir ir miesto dramos, kai reikia lėto tempo ir tamsių gatvių.',
          alt: 'Kino juostos ritės',
        },
        {
          title: 'Šeimos salė',
          text: 'Šviesesni filmai bendram vakarui, be skubėjimo.',
          alt: 'Žiūrovai kino salėje',
        },
        {
          title: 'Kelias kadre',
          text: 'Istorijos apie kelius, uostus ir išvykimą.',
          alt: 'Filmavimo kamera aikštelėje',
        },
        {
          title: 'Tylūs portretai',
          text: 'Kamerinės istorijos ir artimi veikėjų planai.',
          alt: 'Didelis kino ekranas tamsioje salėje',
        },
      ],
    },
    en: {
      eyebrow: 'Collections',
      title: 'Lanes for the mood of the evening',
      subtitle: 'Each lane has its own pace. Open the one that fits tonight.',
      open: 'Open this lane',
      items: [
        {
          title: 'Night city',
          text: 'Noir and city dramas for a slower pace and darker streets.',
          alt: 'Film reels',
        },
        {
          title: 'Family hall',
          text: 'Lighter films for a shared evening, without a rush.',
          alt: 'An audience seated in a cinema',
        },
        {
          title: 'Road in frame',
          text: 'Stories about roads, harbours, and departure.',
          alt: 'A film camera on a set',
        },
        {
          title: 'Quiet portraits',
          text: 'Chamber stories and close views of the characters.',
          alt: 'A large cinema screen in a dark hall',
        },
      ],
    },
  };

  const t = texts[language];

  return (
    <section id="section-2" className="border-b border-white/10 py-20">
      <div className="mx-auto max-w-6xl px-5">
        <div className="max-w-2xl">
          <p className="text-xs uppercase tracking-[0.28em] text-amber">{t.eyebrow}</p>
          <h2 className="mt-4 font-heading text-4xl text-paper sm:text-5xl">{t.title}</h2>
          <p className="mt-4 text-lg text-sand">{t.subtitle}</p>
        </div>

        <div className="mt-12 grid gap-4 lg:grid-cols-12">
          {t.items.map((item, index) => (
            <a
              key={item.title}
              href="/s"
              className={`group relative overflow-hidden border border-white/10 ${lanes[index].span}`}
            >
              <img
                src={lanes[index].image}
                alt={item.alt}
                className={`w-full object-cover transition duration-500 group-hover:scale-105 ${lanes[index].height}`}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/25 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-6">
                <h3 className="font-heading text-3xl text-paper">{item.title}</h3>
                <p className="mt-2 max-w-md text-sm leading-relaxed text-paper/85">{item.text}</p>
                <span className="mt-4 inline-block text-xs uppercase tracking-[0.2em] text-amber">
                  {t.open}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
